export const liquid = {
    outlinePadding: 10,
    liquidBackground: {
        style: {
            lineWidth: 0,
            fillOpacity: .2
        }
    },
    liquidOutline: {
        style: {
            lineWidth: 2
        }
    }
};
//# sourceMappingURL=liquid.js.map
